import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_invoicing_logsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { search?: string, billingContractId?: number, projectId?: number, invoiceId?: number, instructionId?: string, transactionId?: string, requestId?: string, level?: number, $top?: number, $skip?: number }): Promise<{ result?: { logId?: string, level?: number, projectId?: number, billingContractId?: number, invoiceId?: number, instructionId?: string, process?: string, notes?: string, createdOn?: string, alertedOn?: string, transactionId?: string, requestId?: string }[], totalCount?: number }> {
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_invoicing_logs/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { search?: string, billingContractId?: number, projectId?: number, invoiceId?: number, instructionId?: string, transactionId?: string, requestId?: string, level?: number, $keys: string[] }): Promise<{ result?: { logId?: string, level?: number, projectId?: number, billingContractId?: number, invoiceId?: number, instructionId?: string, process?: string, notes?: string, createdOn?: string, alertedOn?: string, transactionId?: string, requestId?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_invoicing_logs/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      search?: string, billingContractId?: number, projectId?: number, invoiceId?: number, instructionId?: string, transactionId?: string, requestId?: string, level?: number    }) {
      return false;
    }
}
